import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'

import CheckmarkIcon from '@/components/CheckmarkIcon'
import { actions } from '@/reducers/asset'

const Radio = ({ variant: { fullVariant, id, isSelected }, disabled }) => {
  const dispatch = useDispatch()

  const changeSelectedVariant = () => {
    if (!isSelected && !disabled) {
      dispatch(actions.updateSelectedVariant(fullVariant))
    }
  }

  return (
    <>
      <input
        className={isSelected ? 'isSelected' : undefined}
        defaultChecked={isSelected}
        disabled={disabled}
        id={id}
        name='variant'
        onChange={changeSelectedVariant}
        type='radio'
        value={id}
      />
      <If condition={isSelected}>
        <CheckmarkIcon />
      </If>
    </>
  )
}

export default Radio

Radio.propTypes = {
  disabled: PropTypes.bool.isRequired,
  variant: PropTypes.shape({
    fullVariant: PropTypes.shape({
      bookshelfAccessDuration: PropTypes.string.isRequired,
      duration: PropTypes.string.isRequired,
      durationInDays: PropTypes.string.isRequired,
      fullPrice: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      isFree: PropTypes.bool.isRequired,
      savings: PropTypes.number.isRequired,
      sku: PropTypes.string.isRequired,
      studentPrice: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired
    }),
    id: PropTypes.number.isRequired,
    isSelected: PropTypes.bool.isRequired
  })
}
